<template>
  <div class="creator-binding-management max-w-7xl mx-auto px-4 py-2">
    <h1 class="text-2xl font-bold mb-6">客户绑定/解绑管理</h1>

    <!-- 查询条件 -->
    <el-card class="mb-4">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="绑定状态">
          <el-select v-model="query.bindingStatus" placeholder="全部" style="width: 160px">
            <el-option :value="null" label="全部" />
            <el-option :value="1" label="已绑定" />
            <el-option :value="2" label="已解绑" />
            <el-option :value="3" label="未绑定" />
          </el-select>
        </el-form-item>

        <el-form-item label="社交账号">
          <el-input
            v-model="query.socialHandle"
            placeholder="如：1mb.girls"
            clearable
            style="width: 220px"
          />
        </el-form-item>

        <el-form-item label="账号SN">
          <el-input
            v-model="query.accountSn"
            placeholder="账号唯一编号"
            clearable
            style="width: 220px"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 结果列表 -->
    <el-card>
      <el-table
        v-loading="loading"
        :data="list"
        border
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="accountSn" label="账号SN" width="140" />
        <el-table-column prop="socialHandle" label="社交账号" min-width="160" />
        <el-table-column prop="platform" label="平台" width="100" />
        <el-table-column prop="creatorId" label="创作者ID" width="120" />
        <el-table-column prop="creatorNickname" label="创作者昵称" min-width="160">
          <template slot-scope="scope">
            <div class="flex items-center">
              <img
                v-if="scope.row.creatorAvatarUrl"
                :src="scope.row.creatorAvatarUrl"
                alt="avatar"
                class="avatar mr-2"
              >
              <span>{{ scope.row.creatorNickname || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="creatorFollowerCount" label="粉丝数" width="120">
          <template slot-scope="scope">
            <span>{{ formatNumber(scope.row.creatorFollowerCount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bindingStatus" label="绑定状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.bindingStatus === 1 ? 'success' : 'info'">
              {{ scope.row.bindingStatus === 1 ? '已绑定' : '未绑定/已解绑' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="verificationStatus" label="认证状态" width="110">
          <template slot-scope="scope">
            <el-tag :type="scope.row.verificationStatus === 1 ? 'success' : 'warning'">
              {{ scope.row.verificationStatus === 1 ? '已认证' : '未认证' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isPrimary" label="主账号" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isPrimary ? 'success' : 'info'">
              {{ scope.row.isPrimary ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="160" />
        <el-table-column prop="updateTime" label="更新时间" min-width="160" />

        <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.bindingStatus !== 1"
              type="success"
              size="mini"
              @click="handleApprove(scope.row)"
            >
              通过
            </el-button>
            <el-button
              v-if="scope.row.bindingStatus === 1"
              type="danger"
              size="mini"
              @click="handleUnbind(scope.row)"
            >
              解绑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="flex justify-between items-center mt-4">
        <div class="text-gray-600 text-sm">
          共 {{ pagination.totalCount }} 条记录，{{ pagination.totalPages }} 页
        </div>
        <el-pagination
          background
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.totalCount"
          :page-size="pagination.pageSize"
          :current-page="pagination.pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import creatorService from '@/services/creatorService'

export default {
  name: 'CreatorBindingManagement',
  data() {
    return {
      loading: false,
      query: {
        bindingStatus: 1,
        socialHandle: '',
        accountSn: ''
      },
      list: [],
      pagination: {
        totalCount: 0,
        pageSize: 20,
        pageIndex: 1,
        totalPages: 0
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const params = {
          bindingStatus: this.query.bindingStatus,
          socialHandle: this.query.socialHandle || null,
          accountSn: this.query.accountSn ? Number(this.query.accountSn) : null,
          pageSize: this.pagination.pageSize,
          pageIndex: this.pagination.pageIndex
        }

        const res = await creatorService.getCreatorBindingList(params)

        if (res && res.success) {
          this.list = res.data || []
          this.pagination.totalCount = res.totalCount || 0
          this.pagination.pageSize = res.pageSize || this.pagination.pageSize
          this.pagination.pageIndex = res.pageIndex || this.pagination.pageIndex
          this.pagination.totalPages = res.totalPages || 0
        } else {
          this.list = []
          this.pagination.totalCount = 0
          this.pagination.totalPages = 0
          this.$message.error(res && res.errMessage ? res.errMessage : '获取绑定列表失败')
        }
      } catch (error) {
        console.error('获取绑定列表失败:', error)
        this.$message.error('获取绑定列表失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.pageIndex = 1
      this.fetchList()
    },
    handleReset() {
      this.query = {
        bindingStatus: 1,
        socialHandle: '',
        accountSn: ''
      }
      this.pagination.pageIndex = 1
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageIndex = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.pageIndex = page
      this.fetchList()
    },
    formatNumber(value) {
      if (value == null) return '-'
      if (value >= 10000) {
        return (value / 10000).toFixed(1) + '万'
      }
      return value.toString()
    },
    async handleApprove(row) {
      try {
        await this.$confirm(`确认通过该绑定申请？（账号：${row.socialHandle}）`, '提示', {
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        this.loading = true
        const res = await creatorService.approveCreatorBinding(row.id)
        if (res && res.success) {
          this.$message.success('操作成功')
          this.fetchList()
        } else {
          this.$message.error(res && res.errMessage ? res.errMessage : '操作失败')
        }
      } catch (error) {
        console.error('通过绑定失败:', error)
        this.$message.error('操作失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },
    async handleUnbind(row) {
      try {
        await this.$confirm(`确认解绑该客户？（账号：${row.socialHandle}）`, '提示', {
          type: 'warning'
        })
      } catch (e) {
        return
      }

      try {
        this.loading = true
        const res = await creatorService.unbindCreatorBinding(row.id)
        if (res && res.success) {
          this.$message.success('解绑成功')
          this.fetchList()
        } else {
          this.$message.error(res && res.errMessage ? res.errMessage : '解绑失败')
        }
      } catch (error) {
        console.error('解绑失败:', error)
        this.$message.error('解绑失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.creator-binding-management {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  object-fit: cover;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.text-sm {
  font-size: 0.875rem;
}

.text-gray-600 {
  color: #4b5563;
}
</style>


